import { TableParams } from '../types';

export const testingTypes = {
  GET_TEST_REGISTRATIONS: 'GET_TEST_REGIDTRATIONS',
  GET_TEST_RESULTS: 'GET_TEST_RESULTS',
  GET_TEST_DETAIL_INFO: 'GET_TEST_DETAIL_INFO',
};

export type ITestingState = Readonly<{
  testings: Array<any>;
}>;

export type GetTestingDetailParam = { id: string };

export type GetTestingsParams = TableParams & {
  isTested?: boolean[];
  privilegeTypeIds?: number[];
  labId?: number[];
};
